import {Component} from '@angular/core';
import {Api} from "../../providers/api";
import { NavController,ModalController,ToastController} from 'ionic-angular';
import {CartManager} from "../../providers/cart-manager";
import {MsgManager} from "../../providers/msg-manager";
import {SpinnerDialog} from "ionic-native";
import {GVLogger} from "../../services/gv-logger";
import {LoginPage} from "../login/login";


@Component({
  selector: 'page-classes',
  templateUrl: 'classes.html',
})
export class ClassesPage {
private categories:any = [];


  constructor(
    private api:Api,
    private nav:NavController,
    private modalController:ModalController,
    private cartManager:CartManager,
    private msgManager:MsgManager,
    private toastController:ToastController,
    private gVLogger: GVLogger
    ){

    this.api.get("category/allActiveInactive").map(res => res.json())
      .subscribe(data =>{

        for(let cat of data.data){
            if(cat.categoryType == "CLASS"){
              this.categories.push(cat);
            }
        }


          // this.categories = data.data;
      });


  }







  toggleStatus(cat){
    let tempState = cat.displayOnScreen;
    let tempStateInverse;
    if(tempState == 0){
      tempStateInverse = 1;
    }else{
      tempStateInverse = 0;
    }

    if (tempState == true) {
      tempState = 1
    }else{
      tempState = 0
    }

    let body  = cat ;
          body.id =  cat.id;
         body.displayOnScreen = tempState;


      this.gVLogger.log("body: "+body);
      this.gVLogger.log("cat: "+cat);
    SpinnerDialog.show(this.msgManager.getLoadingMsg());
    this.api.post("category/update",body).map(res => res.json()).subscribe(result =>{
      if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }
    if(result.status == "200"){
      this.gVLogger.log("on ststus 200" + result.status);
    this.toastMsg(result.message);
    }else{
      this.toastMsg(result.message);
      cat.displayOnScreen = tempStateInverse;
    }
    SpinnerDialog.hide();
    }, error =>{
    this.toastMsg(this.msgManager.getWentWrongMsg());
    cat.displayOnScreen = tempStateInverse;
    SpinnerDialog.hide();
    });



  }


toastMsg(msg){
    let taost = this.toastController.create({
        message: msg,
        duration: 3000
    });
    taost.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/classes/classes.ts